import React, { Component } from "react"

class QuestionType7 extends Component {

  constructor(props) {
    super(props)
    if (props.questionnaire && typeof props.questionnaire[props.name] !== "undefined") {
      if (props.questionnaire[props.name].value === false || props.questionnaire[props.name] === false) {
        this.state = {
          data: {},
          formErrors: {},
          yes: false,
          no: true
        }
        this.props.checkFormValid(this.props.name, true)
        return
      }
    }

    if (props.questionnaire && props.questionnaire[props.name]) {
        this.state = {
          data: props.questionnaire[props.name].value,
          formErrors: {},
          yes: true,
          no: false
        }
      this.props.checkFormValid(this.props.name, true)
    } else {
      this.state = {
        data: {},
        formErrors: {},
        yes: false,
        no: false
      }
      this.props.checkFormValid(this.props.name, false)
    }
  }
  handleChange = (name, value) => {
    let data = {value, name}
    this.setState((prev) => {
      prev.data[data.name] = data.value
      this.props.onChange(this.props.name, {value: prev.data})
      return {data: prev.data}
    })

  }
  handleNoCheckboxChange = (event) => {
    this.setState({yes: false, no: true})
    if (this.props.simple) {
      this.props.onChange(this.props.name, false)
    } else {
      this.props.onChange(this.props.name, {value: false})
    }
    this.props.checkFormValid(this.props.name, true)
  }
  handleYesCheckboxChange = (event) => {
    this.setState({yes: true, no: false})
    if (!this.props.children) {
      if (this.props.simple) {
        this.props.onChange(this.props.name, true)
      } else {
        this.props.onChange(this.props.name, {value: true})
      }
      this.props.checkFormValid(this.props.name, true)
    }
  }
  checkFormValid = (name, value) => {
    this.setState((prev, props) => {
      prev.formErrors[name] = value;
      this.props.checkFormValid(props.name, Object.values(prev.formErrors).reduce((a, b) => a && b))
      return { formErrors: prev.formErrors };
    });
  }
  render() {
    const {label, questionnaire, name, children, simple} = this.props
    let childrenWithProps = React.Children.map(children, (child) => {
      return React.cloneElement(child, { checkFormValid: this.checkFormValid, onChange: this.handleChange,
        questionnaire: questionnaire && questionnaire[name] ? questionnaire[name].value || undefined : {} })
    })
    return (
      <div>
        <div className={!simple ? "aps-questionnaire-answers uk-grid":"aps-questionnaire-answers aps-questionnaire-ans-box-padding-bottom uk-grid"} data-uk-grid>
          <div className="uk-width-expand aps-questionnaire-answers-first-col uk-first-column">
            <div className={!simple ? "aps-questionnaire-answers-title uk-text-bold":"aps-questionnaire-answers-box-title"}>
            {label}
            </div>
          </div>
          <div className="uk-width-1-4 aps-questionnaire-answers-second-col uk-text-right">
            <span className="aps-questionnaire-answers-checkbox-first-content">
              <label className="aps-questionnaire-answers-label">
                <input checked={this.state.yes} onChange={this.handleYesCheckboxChange} className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                Oui
              </label>
            </span>
            <span className="aps-questionnaire-answers-checkbox-second-content">
              <label className="aps-questionnaire-answers-label">
                <input checked={this.state.no} onChange={this.handleNoCheckboxChange}  className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                Non
              </label>
            </span>
          </div>
        </div>
        <div className="aps-questionnaire-ans-box-container">
          <div className="aps-questionnaire-ans-box">
            {this.state.yes && childrenWithProps}
          </div>
        </div>
      </div>
    )
  }
}

export default QuestionType7;



// WEBPACK FOOTER //
// ./src/components/Questionnaire/QuestionType7.js